<template>
  <div class="item-unit-modal"> 
      <div class="card-body">
        <div class="form-group row">
            <div class="col-md-6">
                <label class="form-label">{{ $t('general.cashflow_calculation') }}</label>
                <div class="input-field">
                    <span v-html="currency"></span><span v-html="invoiceTotal/100"></span>-<span v-html="currency"></span><span v-html="withholding_tax_rate"></span>
                </div>
            </div> 
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeCashFlowValueInvoiceModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
        isEdit: false,
        isLoading: false,
        invoiceTotal: 0,
        withholding_tax_rate: 0,
        currency:null
    }    
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]), 
  },
  created(){
  },
 validations: {},
  async mounted () {
    if (this.modalData) {
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    resetFormData () {  
        this.invoiceTotal= 0,
        this.withholding_tax_rate= 0,
        this.currency=null
    },
    async setData () {
      this.invoiceTotal= this.modalData.invoiceTotal,
      this.withholding_tax_rate= this.modalData.withholding_tax_rate,
      this.currency=this.modalData.currency.prefix
    },
    closeCashFlowValueInvoiceModal () {
      this.resetFormData()
      this.closeModal()
    },
  }
}
</script>
